import React, { useState, useEffect, useRef } from 'react'
// import Popover from "@mui/material/Popover";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogContentText,
  Popover, Typography, DialogTitle, MenuItem, Select, InputLabel, FormControl, TextField,
  IconButton, Modal, Divider, Grid, InputAdornment
} from "@mui/material";
import { MuiTelInput } from 'mui-tel-input'
import axios from 'axios';
// import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import { ReactComponent as Father } from "../../../../../Assets/img/GroupCardsImage/father.svg";
import { ReactComponent as Mother } from "../../../../../Assets/img/GroupCardsImage/mother.svg";
// import { ReactComponent as Husband } from "../../../../../Assets/img/GroupCardsImage/husbandweb.svg";
import { ReactComponent as Wife } from "../../../../../Assets/img/GroupCardsImage/wifeweb.svg";
import { ReactComponent as Kids } from "../../../../../Assets/img/GroupCardsImage/kidsweb.svg";
import { ReactComponent as Addcontact } from "../../../../../Assets/img/GroupCardsImage/addcontact.svg";
// import EditRoundedIcon from '@mui/icons-material/EditRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import facebook from '../../../../../Assets/img/icons/Facebook.svg'
import whatsapp from '../../../../../Assets/img/icons/whatsapp.svg'
import insta from '../../../../../Assets/img/icons/instagram.svg'
import linkedin from '../../../../../Assets/img/icons/linkedin.svg'
import signal from '../../../../../Assets/img/icons/signal.svg'
import telegram from '../../../../../Assets/img/icons/Telegram.svg'
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import VerifySuccess from '../../../../../Assets/img/Email-Verified.png'
import { ReactComponent as VerifiedTick } from "../../../../../Assets/img/icons/verified-tick.svg"
import useApi from '../../../../Utilities/useAPI';
import AddContactMembers from './AddContactMembers';
import ProfilePicEditComponent from '../../../../Utilities/ProfilePicEditComponent';
import { useQuantityContext } from '../../../../QuantityContext';
import { useSelector } from 'react-redux';
import { useUserDetailContext } from '../../../../UserDetailContext';
import { getPersonalProfileFamilyReducer } from '../../../../../Redux/Reducers/ProfileReducer';
import { useDispatch } from 'react-redux';
import { getFamilyCardReducer } from '../../../../../Redux/Reducers/CardReducer';
import { InviteProfile } from '../../../MyProfileDetails/ProfileConnectionComponents';

const AddMemberToGroupCard = ({ anchorEl, setAnchorEl, group_id, InviteLightBox, setInviteLightBox,
  father = null, mother = null, spouse = null
}) => {
  const { callApiFunction } = useApi();
  // const [AddtoContactRelationShip, setSelectedRelationShip] = useState('');
  const dispatch = useDispatch();
  const [addToContactClicked, setAddtoContactClicked] = useState(false);
  const { handleSuccess, handleFailure, handleInfo } = useQuantityContext();

  const Familydata = useSelector((state) => state?.ProfileArray?.FamilyData?.data || []);

  // Get available relationship options based on existing members
  const getAvailableRelationships = () => {
    const relationships = [
      {
        label: 'FATHER',
        icon: <Father />,
        available: !father
      },
      {
        label: 'MOTHER',
        icon: <Mother />,
        available: !mother
      },
      {
        label: 'SPOUSE',
        icon: <Wife />,
        available: !spouse
      },
      {
        label: 'KID',
        icon: <Kids />,
        available: true // Always available since multiple kids are allowed
      }
    ];

    if (!addToContactClicked && !InviteLightBox) { //at this time, I dont want this Option
      relationships.push({
        label: 'Add from Contact',
        icon: <Addcontact />,
        available: true
      });
    }
    return relationships;
  };
  const { userDetails } = useUserDetailContext();

  const [contactOpen, setContactOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const [showMessageTextField, setshowmessageTextField] = useState(false);

  const [showEmailTextField, setShowEmailTextField] = useState(false);

  useEffect(() => {
    setAddtoContactClicked(false);  //When Initially Showing Add from Contact Should be there
  }, [anchorEl])

  const isOpen = Boolean(anchorEl);
  const [relationSelected, setRelationSelected] = useState('');
  const isfetched = useRef(false);
  const handleContactOpen = () => {
    setAddtoContactClicked(true);
    // setSelectedRelationShip(''); //Initialize with empty to Select Properly Next
    // setContactOpen(true); This Should be Open when RelationShip of Contact is Selected
  };

  const [formValues, setFormValues] = useState({
    groupId: group_id,
    group_category: 'FAMILY',
    relationship: '',
    isVerified: false,
    firstName: '',
    lastName: '',
    phoneNumber: '+91 ',
    email: '',
    profile_url: '',
    dob: '',
    blood_group: '',
    gender: '',
  });

  const handleRelationShipSelect = (label) => {
    setInviteLightBox(false);
    setAddtoContactClicked(false);
    setRelationSelected(label)
    setContactOpen(true);
  }

  const handleClickOpen = (Person) => {
    console.log("CLICKED Name", Person);
    setRelationSelected(Person);
    handleOpenDialog(Person);
    setOpen(true);
    setFormValues(prevState => ({
      ...prevState,
      relationship: Person?.toUpperCase(),
    }));
  };


  const handleOpenDialog = (relation) => {
    console.log("Family Data:", Familydata); // Debugging to check data availability

    // Find the selected relative's data from the response
    const selectedRelative = Familydata?.find(item =>
      item.relation_name.toLowerCase() === relation.toLowerCase()
    );

    console.log("SELECTED FAMILY DATA", selectedRelative);

    // If relation exists, pre-fill the form
    if (selectedRelative) {
      setFormValues({
        relationship: relation,
        firstName: selectedRelative.relative_first_name || '',
        lastName: selectedRelative.relative_last_name || '',
        email: selectedRelative.guardian_email || '',
        phoneNumber: selectedRelative.guardian_phone_no || '',
        dob: selectedRelative.relative_dob ? selectedRelative.relative_dob.substring(0, 10) : '', // Ensure proper date format
        blood_group: selectedRelative.relative_blood_group || '',
        isVerified: selectedRelative.is_guardian_verified || false,
      });
    } else {
      // Reset form if no relation is found
      setFormValues({
        relationship: relation,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        dob: '',
        blood_group: '',
        isVerified: false,
      });
    }

    console.log("Updated Form Values:", formValues); // Debugging if form is being updated
  };


  // const handleOpenDialog = (relation) => {
  //   // Find the selected relative's data from the response
  //   const selectedRelative = Familydata?.find(item =>
  //     item.relation_name.toLowerCase() === relation.toLowerCase()
  //   );
  //   console.log("SELECTED FAMILY DATA", selectedRelative);
  //   // If relation exists, pre-fill the form
  //   if (selectedRelative) {
  //     setFormValues({
  //       relationship: relation,
  //       firstName: selectedRelative.relative_first_name || '',
  //       lastName: selectedRelative.relative_last_name || '',
  //       email: selectedRelative.guardian_email || '',
  //       phoneNumber: selectedRelative.guardian_phone_no || '',
  //       dob: selectedRelative.relative_dob || '',
  //       blood_group: selectedRelative.relative_blood_group || '',
  //       isVerified: selectedRelative.is_guardian_verified || false,
  //     });
  //   } else {
  //     // Reset form if no relation is found
  //     setFormValues({
  //       relationship: relation,
  //       firstName: '',
  //       lastName: '',
  //       email: '',
  //       phoneNumber: '',
  //       dob: '',
  //       blood_group: '',
  //       isVerified: false,
  //     });
  //   }

  //   console.log("Updated Form Values:", formValues);


  //   setOpen(true); // Open the dialog
  // };


  const handleFormClose = () => {
    setOpen(false);
  };

  const formatPhoneNumber = (phoneNumber) => {
    const match = phoneNumber.match(/^(\+\d{1,3})\s?(.*)$/);
    if (match) {
      const countryCode = match[1]; // country code part
      const mainNumber = match[2].replace(/\s+/g, ""); // removes internal spaces from main number
      return `${countryCode} ${mainNumber}`;
    }
    return phoneNumber; // returns the original if it doesn't match
  };

  const [openInvite, setOpenInvite] = useState(false);
  const apiKey = process.env.REACT_APP_API_KEY
  const objectId = localStorage.getItem('objectId');
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
  };

  const handleInviteOpen = async () => {
    // if (isfetched.current) return;
    // isfetched.current = true;
    // const apiPayload = {
    //   ...formValues,
    //   phoneNumber: formatPhoneNumber(formValues.phoneNumber)
    // };
    const formData = new FormData();

    // console.log("group_id", group_id);
    formData.append("groupId", Number(group_id));
    formData.append("group_category", "FAMILY");
    formData.append("relationship", formValues.relationship || "");
    formData.append("isVerified", formValues.isVerified ? "true" : "false"); // Convert boolean to string
    formData.append("firstName", formValues.firstName || "");
    formData.append("lastName", formValues.lastName || "");
    formData.append("phoneNumber", formValues.phoneNumber || "+91 "); // Ensure prefix remains
    formData.append("email", formValues.email || "");

    if (formValues?.profile_url) {

      formData.append('profile_pic', formValues?.profile_url);
    }
    formData.append("dob", formValues.dob || "");
    formData.append("blood_group", formValues.blood_group || "");
    formData.append("gender", formValues.gender || "");
    formData.append("requesterName", userDetails.name || "");
    formData.append("role", "MEMBER" || "");


    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/group-card/directly_add_member`, formData,
        {
          headers: {
            'x-api-key': apiKey,
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${objectId}`,
          }
        });

      const response = res.data;
      console.log("HELLO THIS IS INSIDE THE GROUP");


      if (response.statusCode === 200) {
        setOpenInvite(true);
        handleFormClose();
        handleSuccess('New User Added into the Group', "success", 6000);
        await dispatch(getPersonalProfileFamilyReducer());
        await dispatch(getFamilyCardReducer(group_id));
      }

    } catch (error) {
      // console.error("API Error:", error);
      // handleFailure('Refresh and Try Again Later.', "error", 6000);
      if (error.response && error.response.status === 409) {
        const countryCode = formValues.phoneNumber.split(' ')[0]; // Assuming country code is the first part
        setFormValues({

          phoneNumber: `${countryCode} ` // Keep country code and a space
        });
        // setFormValues({ phoneNumber: formatPhoneNumber(formValues.phoneNumber) });
        handleFormClose();
        handleInfo('User with this phone number or email already exists.', "error", 6000);

      } else {
        console.error("API Error:", error);
        handleFailure('Refresh and Try Again Later.', "error", 6000);
        handleFormClose();
      }
    }
  };
  const handleInviteClose = () => {
    setOpenInvite(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePhoneChange = (value) => {
    setFormValues(prevState => ({
      ...prevState,
      phoneNumber: value,
    }));
  }

  // const { profile_url } = formValues;
  // const isFormValid = Object.values(requiredFields).every(value => value !== '');
  const {
    firstName,
    lastName,
    dob,
    gender,
    relationship,
    groupId,
    group_category,
    isVerified,
    blood_group,
    profile_url,
  } = formValues;
  const isFormValid = [firstName, lastName, dob, gender, relationship, groupId, group_category, isVerified, blood_group]
    .every(value => value !== '');

  const updateProfileUrl = (sasUrl) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      profile_url: sasUrl, // Save the server URL for the image
    }));
  };


  // Function to handle file upload to server
  const handleFileUpload = async (file) => {
    if (!file) {
      console.error('No file to upload.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const sasUrl = response.data.url;
      console.log("File uploaded successfully!", sasUrl);

      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        profile_url: sasUrl, // Save the server URL for the image
      }));
    } catch (error) {
      console.error('Error uploading file:', error.message);
      handleInfo('Error uploading file. Please check the console for details.');
    }
  };

  const handleContactClose = () => {
    setContactOpen(false);
  };

  // -------------------------------Latest Code----------------------------
  const [openFamilyVerify, setOpenFamilyVerify] = useState(false);

  // OTP State Variables
  const [emailOtp, setEmailOtp] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [phoneOtp, setPhoneOtp] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);

  // Timer State Variables
  const [emailOtpSeconds, setEmailOtpSeconds] = useState(0); // Timer for email OTP
  const [phoneOtpSeconds, setPhoneOtpSeconds] = useState(0); // Timer for phone OTP

  // Timer Logic for Email OTP
  useEffect(() => {
    if (emailOtpSeconds > 0) {
      const timer = setTimeout(() => setEmailOtpSeconds(emailOtpSeconds - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [emailOtpSeconds]);

  // Timer Logic for Phone OTP
  useEffect(() => {
    if (phoneOtpSeconds > 0) {
      const timer = setTimeout(() => setPhoneOtpSeconds(phoneOtpSeconds - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [phoneOtpSeconds]);

  // Email OTP Functions
  const sendEmailOtp = async (email) => {
    try {
      const response = await axios.post('onboard/twofactor-second-otp', { email }, { headers });
      if (response.status === 200) {
        setEmailError('');
        setEmailOtp('');
        setEmailOtpSeconds(60); // Reset email OTP timer
      }
      else {
        setEmailError("Enter Valid Email ID");
      }
    } catch (error) {
      setEmailError("Enter Valid Email ID");
      console.error("Failed to send OTP to email", error);
    }
  };

  const verifyEmailOtp = async (email) => {
    try {
      const response = await axios.post('onboard/twofactor-verify-otp', { email, otp: emailOtp }, { headers });
      if (response.status === 200) {
        setIsEmailVerified(true);
        setEmailError('');
        await sendPhoneOtp(formValues.phoneNumber);
      }
    } catch (error) {
      setEmailError('Invalid Email OTP. Try Again.');
    }
  };

  // Phone OTP Functions
  const sendPhoneOtp = async (phoneNo) => {
    try {
      const response = await axios.post('/mail/Contact-send-mob-otp', { mobileNumber: phoneNo }, { headers });
      if (response.status === 200) {
        setPhoneError('');
        setPhoneOtp('');
        setPhoneOtpSeconds(60); // Reset phone OTP timer
      }
      else {
        setPhoneError("Enter Valid Phone Number");
      }
    } catch (error) {
      setPhoneError("Something Wrong! Check Phone Number");
      console.error("Failed to send OTP to phone", error);
    }
  };

  const verifyPhoneOtp = async (phoneNo) => {
    try {
      const response = await axios.post('/mail/verify-mobile-otp', { mobileNumber: phoneNo, otp: phoneOtp }, { headers });
      if (response.status === 200) {
        setIsPhoneVerified(true);
        setPhoneError('');
        setFormValues(prevState => ({
          ...prevState,
          isVerified: true,
        }));
      }
      else {
        setPhoneError('Enter Valid Email ID');
      }
    } catch (error) {
      setPhoneError('Invalid Phone OTP. Try Again.');
    }
  };

  // Function to copy the URL to the clipboard
  const copyToClipboard = () => {
    const url = `https://app.neoin.co/familyCard/${group_id}`;
    navigator.clipboard.writeText(url).then(() => {
      handleSuccess('Group Card Link Copied', "success", 6000);
    }).catch((err) => {
      console.error("Failed to copy: ", err);
    });
  };

  return (
    <>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div>
          <Box sx={{ padding: "12px" }}>
            <Typography>
              {addToContactClicked
                ? "Choose Relationship for Adding"
                : "Choose Relationship"
              }
            </Typography>
            <div
              className="mt-1 d-flex flex-wrap gap-2 justify-content-start"
              style={{ maxWidth: '350px' }}
            >
              {getAvailableRelationships()
                .filter(rel => rel.available)
                .map(({ label, icon }) => (
                  <Button
                    key={label}
                    className="flex-center flex-column p-4"
                    sx={{
                      border: '2px solid rgba(217, 217, 217, 1)',
                      borderRadius: '8px',
                      color: 'rgba(0, 0, 0, 0.6)',
                      width: '100px',
                      height: '100px',
                      textTransform: 'none',
                    }}
                    onClick={label === 'Add from Contact'
                      ? handleContactOpen
                      : addToContactClicked
                        ? () => handleRelationShipSelect(label)
                        : () => handleClickOpen(label)
                    }
                  >
                    {icon}
                    <div>{label}</div>
                  </Button>
                ))}
            </div>
          </Box>
        </div>
      </Popover>

      <Dialog open={InviteLightBox} onClose={() => { setInviteLightBox(false) }}>
        <Box sx={{ padding: "12px" }}>
          {/* <Tooltip title="Add Relationship" arrow>
            <Typography>Choose Relationship for Adding</Typography>
          </Tooltip> */}
          <DialogTitle className='ps-0 flex-center-between gap-2'>
            <div className='capitalize-first-letter'>Choose Relationship for Adding</div>
            <div onClick={() => { setInviteLightBox(false) }}>
              <IconButton className="">
                <CloseRoundedIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <div className="mt-1 d-flex flex-wrap justify-content-center gap-2" >
            {getAvailableRelationships()
              .filter(rel => rel.available)
              .map(({ label, icon }) => (
                <Button
                  key={label}
                  className="flex-center flex-column p-4"
                  sx={{
                    border: '2px solid rgba(217, 217, 217, 1)',
                    borderRadius: '8px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    width: '100px',
                    height: '100px',
                    textTransform: 'none',
                  }}
                  onClick={() => { handleRelationShipSelect(label); }}
                >
                  {icon}
                  <div>{label}</div>
                </Button>
              ))}
          </div>
        </Box>
      </Dialog>

      <Dialog open={open} onClose={handleFormClose} sx={{ justifyContent: "center" }}>
        <DialogTitle sx={{ display: "flex", flexDirection: "row ", justifyContent: "space-between" }}>
          <div className='capitalize-first-letter'>Add {relationSelected.toLowerCase()} Details</div>
          <div onClick={handleFormClose}>
            <IconButton className="modal-close-button">
              <CloseRoundedIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent className='my-0 py-0' style={{ overflowY: "unset" }}>
          <DialogContentText sx={{ display: "flex", justifyContent: "center", margin: 0 }}>
            <div> Add Photo</div>
          </DialogContentText>

          <Box className="mb-0" sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <ProfilePicEditComponent
              fieldName="profile_picture"
              value={formValues.profile_url}
              acceptedFormats="image/*"
              onChange={updateProfileUrl}  // Callback to update profile URL
            />
          </Box>
          <Grid container spacing={2}>
            {/* Relationship Type */}
            <Grid item xs={6}>
              <FormControl variant="outlined" required fullWidth disabled>
                <InputLabel id="relationship-label">Relationship</InputLabel>
                <Select
                  labelId="relationship-label"
                  name="relationship"
                  value={formValues.relationship}
                  onChange={handleChange}
                  label="Relationship"
                >
                  <MenuItem value="FATHER">Father</MenuItem>
                  <MenuItem value="MOTHER">Mother</MenuItem>
                  <MenuItem value="SPOUSE">Spouse</MenuItem>
                  <MenuItem value="KID">Kid</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Gender */}
            <Grid item xs={6}>
              <FormControl variant="outlined" required fullWidth>
                <InputLabel id="gender-label">Gender</InputLabel>
                <Select
                  labelId="gender-label"
                  name="gender"
                  value={formValues.gender}
                  onChange={handleChange}
                  label="Gender"
                >
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Non-binary/Other">Non-binary/Other</MenuItem>
                  <MenuItem value="Prefer not to say">Prefer not to say</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* First Name */}
            <Grid item xs={6}>
              <TextField
                name="firstName"
                variant="outlined"
                label="First Name"
                required
                fullWidth
                value={formValues.firstName}
                onChange={handleChange}
              />
            </Grid>

            {/* Last Name */}
            <Grid item xs={6}>
              <TextField
                name="lastName"
                variant="outlined"
                label="Last Name"
                required
                fullWidth
                value={formValues.lastName}
                onChange={handleChange}
              />
            </Grid>

            {/* Email */}
            {relationSelected.toLowerCase() === "kid" ? <Grid item xs={6}>
              <TextField
                name="email"
                variant="outlined"
                label="Email ID"
                // required
                fullWidth
                value={formValues.email}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <>
                      {formValues.email ?
                        <InputAdornment position="end">
                          <VerifiedTick className={formValues.isVerified && 'green-verified-tick'} />
                        </InputAdornment>
                        : <> </>}
                    </>
                  )
                }}
              />
            </Grid> : <Grid item xs={6}>
              <TextField
                name="email"
                variant="outlined"
                label="Email ID"
                required
                fullWidth
                value={formValues.email}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <>
                      {formValues.email ?
                        <InputAdornment position="end">
                          <VerifiedTick className={formValues.isVerified && 'green-verified-tick'} />
                        </InputAdornment>
                        : <> </>}
                    </>
                  )
                }}
              />
            </Grid>}

            {/* Phone Number (Using MuiTelInput) */}

            {relationSelected.toLowerCase() === 'kid' ? <Grid item xs={6}>
              <MuiTelInput
                name="phone"
                variant="outlined"
                label="Phone Number"
                // required
                fullWidth
                value={formValues.phoneNumber}
                onChange={handlePhoneChange} // Assuming a handler for phone input
                InputProps={{
                  endAdornment: (<>
                    {formValues.phoneNumber ?
                      <InputAdornment position="end">
                        <VerifiedTick className={formValues.isVerified && 'green-verified-tick'} />
                      </InputAdornment>
                      : <> </>}
                  </>)
                }}
              />
            </Grid> : <Grid item xs={6}>
              <MuiTelInput
                name="phone"
                variant="outlined"
                label="Phone Number"
                required
                fullWidth
                value={formValues.phoneNumber}
                onChange={handlePhoneChange} // Assuming a handler for phone input
                InputProps={{
                  endAdornment: (<>
                    {formValues.phoneNumber ?
                      <InputAdornment position="end">
                        <VerifiedTick className={formValues.isVerified && 'green-verified-tick'} />
                      </InputAdornment>
                      : <> </>}
                  </>)
                }}
              />
            </Grid>}

            {/* Date of Birth */}
            <Grid item xs={6}>
              <TextField
                name="dob"
                variant="outlined"
                label="Date of Birth"
                type="date"
                required
                fullWidth
                value={formValues.dob}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            {/* Blood Group */}
            <Grid item xs={6}>
              <FormControl variant="outlined" required fullWidth>
                <InputLabel id="blood-label">Blood Group</InputLabel>
                <Select
                  labelId="blood-label"
                  name="blood_group"
                  value={formValues.blood_group}
                  onChange={handleChange}
                  label="Blood Group"
                >
                  <MenuItem value="A+">A+</MenuItem>
                  <MenuItem value="A-">A-</MenuItem>
                  <MenuItem value="B+">B+</MenuItem>
                  <MenuItem value="B-">B-</MenuItem>
                  <MenuItem value="AB+">AB+</MenuItem>
                  <MenuItem value="AB-">AB-</MenuItem>
                  <MenuItem value="O+">O+</MenuItem>
                  <MenuItem value="O-">O-</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ padding: "20px 24px" }} className='d-flex align-items-center justify-content-between'>
          <Button variant="contained" sx={{ backgroundColor: '#0044C6' }}
            onClick={() => { setOpenFamilyVerify(true); sendEmailOtp(formValues.email); }}
            className={`verify-button ${formValues.isVerified ? 'success-green' : ''}`}>
            {formValues.isVerified ? 'Verified' : 'Verify'}
          </Button>
          <div>
            <Button onClick={handleFormClose} style={{ color: "#0044c6" }}>CANCEL</Button>
            <Button
              type="submit"
              variant="contained"
              onClick={handleInviteOpen}
              disabled={!isFormValid}
              sx={{ backgroundColor: "#0044c6" }}
            >
              ADD
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Modal open={openFamilyVerify} onClose={() => setOpenFamilyVerify(false)}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", minWidth: "40%", bgcolor: 'white', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, p: 3, maxHeight: "80%", overflowY: 'auto' }}>
          {(isPhoneVerified && isEmailVerified) ? (
            <div className="flex-center flex-column">
              <img
                src={VerifySuccess}
                alt="Successfully Verified"
                className="dialogImage"
              />
              <div className="profile-modal-heading1 mb-2">Email ID and Phone Number Verified</div>
              <div className="time-label">Your family details have been successfully verified.</div>
              <Button className="mt-3" variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={() => setOpenFamilyVerify(false)}>Continue</Button>
            </div>
          ) : (
            <div>
              <div className="modal-heading">
                <div className="profile-modal-heading1">Verify Family Member</div>
                <span className='span-center-align file-attach-icon-container'>
                  <IconButton color="rgb(0, 0, 0, 0.54)" onClick={() => setOpenFamilyVerify(false)}>
                    <CloseRoundedIcon />
                  </IconButton></span>
              </div>
              <div className="modal-body">
                <div className="py-4">
                  {/* Email OTP */}
                  <TextField
                    fullWidth
                    value={emailOtp}
                    onChange={(e) => setEmailOtp(e.target.value)}
                    label="Enter Email OTP"
                    autoFocus
                    autoComplete="off"
                    disabled={isEmailVerified}
                    error={!!emailError}
                    helperText={emailError || ' '}
                  />
                  <div className="mt-12px">
                    <span className="helper-text-style">Remaining Time: 00.{emailOtpSeconds < 10 ? `0${emailOtpSeconds}` : emailOtpSeconds}s</span>
                  </div>
                  <div className="d-flex justify-content-between mt-4">
                    <span className="span-center-align">
                      <span className="helper-text-style me-2">Didn't receive the mail?</span>
                      <Button sx={{ color: '#0044C6' }} disabled={isEmailVerified || emailOtpSeconds > 0} onClick={() => sendEmailOtp(formValues.email)}>Resend</Button>
                    </span>
                    <Button variant="contained" sx={{ backgroundColor: '#0044C6' }}
                      disabled={isEmailVerified}
                      onClick={() => verifyEmailOtp(formValues.email)}
                      className={`verify-button ${isEmailVerified ? 'success-green' : ''}`}>
                      {isEmailVerified ? 'Verified' : 'Verify'}
                    </Button>
                  </div>
                </div>

                <Divider sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} />

                <div className="pt-4">
                  {/* Phone OTP */}
                  <TextField
                    fullWidth
                    value={phoneOtp}
                    onChange={(e) => setPhoneOtp(e.target.value)}
                    label="Enter Phone OTP"
                    autoFocus
                    autoComplete="off"
                    disabled={!isEmailVerified}
                    error={!!phoneError}
                    helperText={phoneError || ' '}
                  />
                  <div className="mt-12px">
                    <span className="helper-text-style">Remaining Time: 00.{phoneOtpSeconds < 10 ? `0${phoneOtpSeconds}` : phoneOtpSeconds}s</span>
                  </div>
                  <div className="d-flex justify-content-between mt-4">
                    <span className="span-center-align">
                      <span className="helper-text-style me-2">Didn't receive the SMS?</span>
                      <Button sx={{ color: '#0044C6' }} disabled={!isEmailVerified || phoneOtpSeconds > 0} onClick={() => sendPhoneOtp(formValues.phoneNumber)}>Resend</Button>
                    </span>
                    <Button variant="contained" sx={{ backgroundColor: '#0044C6' }}
                      disabled={!isEmailVerified}
                      onClick={() => verifyPhoneOtp(formValues.phoneNumber)}
                      className={`verify-button ${isPhoneVerified ? 'success-green' : ''}`}>
                      {isPhoneVerified ? 'Verified' : 'Verify'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>)}
        </Box>
      </Modal>

      {/* <Modal open={openInvite} onClose={handleInviteOpen}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", minWidth: "500px", maxWidth: "550px", bgcolor: 'white', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, p: 3, maxHeight: "80%", overflowY: 'auto' }}>

          <div className='d-flex align-items-center justify-content-between'>
            <div className='flex-center align-items-center text-start'>
              <IconButton sx={{ padding: 0 }} onClick={handleInviteClose}>
                <ArrowBackIcon /> </IconButton>
              <div onClick={handleInviteClose} className='ms-1 group_permissiions_options'>
                Back
              </div>
            </div>
            <div onClick={handleInviteClose}>
              <IconButton>
                <CloseRoundedIcon />
              </IconButton>
            </div>
          </div>

          <div className='d-block heading-Lightbox-group mt-3 mb-2' style={{ color: "#000000DE" }}>Invite Family members</div>
          <div className='d-block group_permissiions_options'>Invite a member to join your family group</div>

          <div className='flex-center-between mt-3 gap-3'>
            <div className={`d-flex justify-content-start align-items-center Share_button_Design w-100 ${showEmailTextField ? 'Checked' : ''} `}
              onClick={() => { setShowEmailTextField(!showEmailTextField); setshowmessageTextField(false) }}>
              <div className='flex-center group_card_ShareMethods icon-20px'>
                <EmailIcon style={{ color: "#ffff" }} />
              </div>
              <p className="m-0 p-0 group_permissiions_options">Invite by Email</p>
            </div>

            <div className={`d-flex justify-content-start align-items-center Share_button_Design w-100 ${showMessageTextField ? 'Checked' : ''}`}
              onClick={() => { setshowmessageTextField(!showMessageTextField); setShowEmailTextField(false) }}>
              <div className='flex-center group_card_ShareMethods icon-20px'>
                <TextsmsIcon style={{ color: "#ffff" }} />
              </div>
              <p className="m-0 p-0 group_permissiions_options">Invite by Message</p>
            </div>
          </div>

          {showEmailTextField && (
            <TextField className='mt-2'
              label="Email"
              sx={{ width: "100%" }}
            />
          )}
          {showMessageTextField && (
            <TextField className='mt-2'
              label="+91"
              sx={{ width: "100%" }}
            />
          )}

          <div className='mb-3' style={{ position: "relative" }}>
            <hr
              style={{
                marginTop: "30px",
                backgroundColor: "rgba(0, 0, 0, 0.12)",
              }}
            />
            <p className="m-0"
              style={{
                position: "absolute",
                top: "-18px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#fff",
                padding: "5px",
              }}
            >
              Or
            </p>
          </div>

          <div className='flex-center-between'>
            <a href="#facebook-link" target='_blank' rel='noreferrer'>
              <img src={facebook} alt="facebook" className="share-icons mr-3" />
            </a>
            <a href="#signal-link" target='_blank' rel='noreferrer'>
              <img src={whatsapp} alt='whatsapp' className="share-icons mr-3" />
            </a>
            <a href="#instagram-link" target='_blank' rel='noreferrer'>
              <img src={insta} alt="instagram" className="share-icons mr-3" />
            </a>
            <a href="#linkedin-link" target='_blank' rel='noreferrer'>
              <img src={linkedin} alt="linkedin" className="share-icons mr-3" />
            </a>
            <a href="#signal-link" target='_blank' rel='noreferrer'>
              <img src={signal} alt="signal" className="share-icons mr-3" />
            </a>
            <a href="#signal-link" target='_blank' rel='noreferrer'>
              <img src={telegram} alt='telegram' className="share-icons" />
            </a>
          </div>

          <div className='flex-center-between mt-3'>
            <div className='flex-center hovering_color_change' onClick={copyToClipboard}>
              <InsertLinkIcon />
              <p className='p-0 m-0 ms-2 group_permissiions_options hover'>Copy Invite link</p>
            </div>
            <div className='d-flex gap-3'>
              <Button onClick={handleContactClose} sx={{ color: "#0044c6" }}>CANCEL</Button>
              <Button type="submit" variant="contained" sx={{ backgroundColor: "#0044c6" }}>SEND</Button>
            </div>
          </div>

        </Box>
      </Modal> */}

      <InviteProfile open={openInvite} setModalOpen={setOpenInvite} handleSuccess={handleSuccess} handleFailure={handleFailure} />
      <AddContactMembers contactOpen={contactOpen} handleContactClose={handleContactClose} relationSelected={relationSelected} />
    </>
  )
}

export default AddMemberToGroupCard